import React, { FC } from 'react';
import { createStyles, Theme, Typography, IconButton, WithStyles, withStyles } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import CreateAccountCategoriesForm from './components/CreateAccountCategoriesForm';

interface RoleModel {
  name: string;
}

interface Props {
  accountCategorie: AccountCategoryModel | null;
  type: string;
  typeError: string;
  roles: RoleModel[];
  setType: React.Dispatch<React.SetStateAction<string>>;
  open: boolean;
  accountCategories: AccountCategoryModel[];
  setAccountCategories: React.Dispatch<React.SetStateAction<AccountCategoryModel[]>>;
  setAccountCategorie: React.Dispatch<React.SetStateAction<AccountCategoryModel | null>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleSnackBar: (open: boolean, variant: 'success' | 'error', message: string) => void;
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2)
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1)
    }
  });

interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose?: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant='h6'>{children}</Typography>
      {onClose ? (
        <IconButton aria-label='close' className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiDialogContent);

const CreateAccountCategories: FC<Props> = props => {
  const {
    accountCategorie,
    accountCategories,
    setAccountCategories,
    setAccountCategorie,
    type,
    typeError,
    setType,
    roles,
    open,
    setOpen,
    handleSnackBar
  } = props;

  const handleClose = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
    setOpen(false);
  };

  return (
    <Dialog maxWidth={'sm'} disableBackdropClick={true} onClose={handleClose} aria-labelledby='customized-dialog-title' open={open}>
      <DialogTitle id='customized-dialog-title'>
        <Typography id='modal-title' variant='h1' component='h1'>
          {accountCategorie ? 'Perbaharui Bagan Akun' : 'Tambah Bagan Akun'}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <CreateAccountCategoriesForm
          accountCategorie={accountCategorie}
          accountCategories={accountCategories}
          setAccountCategories={setAccountCategories}
          setAccountCategorie={setAccountCategorie}
          setOpen={setOpen}
          handleSnackBar={handleSnackBar}
          type={type}
          setType={setType}
          typeError={typeError}
          roles={roles}
        />
      </DialogContent>
    </Dialog>
  );
};

export default CreateAccountCategories;
